import { useState } from "react";

function BoxError({ mensagem, aberto, setStatus }) {

    const [hideLightbox, setHideLightbox] = useState(aberto);

    return (
        <div id="popup_error" className="popup" style={{ display: hideLightbox ? "flex" : "none" }}>
            <div className="popup-message error-message">
                <span
                    id="popup_error_close_button"
                    className="material-icons close-message"
                    onClick={() => { setHideLightbox(false); setStatus(""); }}
                >
                    close
                </span>
                <span className="material-icons" style={{ fontSize: "5em", margin: "auto" }} >
                    warning
                </span>
                <div id="popup_error_text" className="message-text">
                    {mensagem}
                </div>
            </div>
        </div>
    );
}

export default BoxError;